<div class="full-menu">
    <div class="navbar">
        <div class="logo-wrapper" (click)="setTitle( 'PULLA' )" [ngClass]="{'hidde-logo-wrapper':hiddeLogo}">
            <img class="logo logo-first d-md-block" (load)="loadHeader()" src="../../../assets/img/Pulla_LogoBlack.svg"
                alt="" [ngClass]="{'logo-first-transform':changeLogo, 'start-logo-transform':loadPulla}">
            <a id="rotate-logo" class="logo logo-second d-md-block"
                [ngClass]="{'change-logo-black': whiteLogo, 'logo-second-transform':changeLogo}"
                (click)="imageEventHandler();initAnimations();toggleMenuOpened();goToTop()"></a>
            <a id="rotate-white-logo" class="logo logo-white d-md-block"
                [ngClass]="{'change-logo-white': whiteLogo, 'logo-second-transform':changeLogo}"
                (click)="imageEventHandler();initAnimations();toggleMenuOpened();goToTop()"></a>
        </div>
        <div class="wrapper-button" [ngClass]="{'fade-wrapper-button':showBackButton}">
            <a *ngIf="screenWidth > 1024" class="link1 link-darker" (click)="imageEventHandlerBack()">Back to work</a>
            <a *ngIf="screenWidth <= 1024" class="link1-mobile link-darker" (click)="imageEventHandlerBack()">Back to
                work</a>
        </div>
        <div class="wrapper-button" [ngClass]="{'fade-wrapper-button':showExitVideoButton}">
            <a *ngIf="screenWidth > 1024" class="link1 link-darker" (click)="exitReelVideo()">Exit Video</a>
            <a *ngIf="screenWidth <= 1024" class="link1-mobile link-darker" (click)="exitReelVideo()">Exit Video</a>
        </div>
        <!-- <p class="testing-theme" (click)="toggleTheme()">THEME</p> -->
        <div #toggleButton class="toggle-button-container" (click)="toggleMenu()">
            <button class="toggle-menu-button"
                [ngClass]="{'active':menuToggle, 'white-menu': whiteLogo, 'menu-transform':loadMenu, 'load-menu':whiteLoadMenu}">
                <span class="top-toggle"></span>
                <span class="bottom-toggle"></span>
            </button>
        </div>
    </div>
    <div class="menu-side-container" [ngClass]="{'active-menu':menuToggle}">
        <div #menu class="menu-wrapper">
            <div class="main-menu-wrapper">
                <ul class="nav-menu" [@fadeAnimation]="menus?.length">
                    <li *ngFor="let menu of menus; let i = index"><a id="{{menu.title == 'Home' ? 'not-active': ''}}" (mouseenter)="menuOnHover(i)" (mouseleave)="menuOnHoverOut()"
                            class="link-white fade-out-2" [ngClass]="{ 
                            'fade-in-2': ( i==0 && ActiveFirst || i==1 && ActiveSecond || i==2 && ActiveThird || i==3 && ActiveFourth || i==4 && ActiveFifth),
                            'link1':screenWidth > 1024,
                            'link1-mobile': screenWidth <= 1024
                        }" (click)="toggleMenu(true)" routerLink="{{handleRouterLink(menu.url)}}"
                            [routerLinkActive]="['active']"> <span class="title-number">0{{i+1}}</span> {{menu.title}}</a></li>
                </ul>
                <ul class="nav-menu-socials" [@fadeAnimation]="socials?.length">
                    <li *ngFor="let social of socials; let i = index"><a target="{{social.target}}"
                            class="link1 link-white fade-out-2"
                            [ngClass]="{ 'fade-in-2': ( i==0 && ActiveEight || i==1 && ActiveNine || i==2 && ActiveTen || i==3 && ActiveEleven || i==4 && ActiveTwelve)}"
                            href="{{social.url}}">{{social.title}}</a></li>
                    <!-- <p class="testing-theme" (click)="toggleTheme()">Change to dark mode</p> -->
                </ul>
                <div class="nav-menu-content" *ngIf="content">
                    <h1 class="fade-out-2" [ngClass]="{'fade-in-2': ActiveThirteen}">{{ content.menu_title }}</h1>
                    <h3 class="fade-out-2" [ngClass]="{'fade-in-2': ActiveFourteen}">{{ content.menu_subtitle }}</h3>
                </div>
                <div class="nav-menu-gallery fade-out-1" [ngClass]="{'fade-in-1': ActiveSeven}">
                    <ng-container *ngFor="let menu of menus; let i = index">
                        <div class="image-wrapper" [ngClass]="{'opened': i == activeImage, 'mobile-image': screenWidth <= 1024}">
                            <img src="{{menu.image}}" alt="{{menu.title}}">
                        </div>
                    </ng-container>
                </div>
            </div>
            <div *ngIf="screenWidth > 1024 && !isIPadPro" class="search-box fade-out-2"
                [ngClass]="{'fade-in-2':ActiveSix}">
                <input [(ngModel)]="searchModel" (keydown.enter)="search($event)" class="search-input" type="text">
                <span class="search-text heading5 d-none d-lg-block">Search</span>
                <button class="search-button d-block d-lg-none" (click)="search($event)">Search</button>
            </div>
        </div>
    </div>
</div>

<div class="top-bar"
    [ngClass]="{'no-bg-set':removeBgColor, 'no-bg-set-desktop':removeBgColorDesktop, 'top-bar-works': worksTopBar}">
    <!----------------------- WORKS -------------------------->
    <div *ngIf="screenWidth <= 1024" (click)="toggleDropdownEvent()" class="top-bar-dropdown-wrapper"
        [ngClass]="{'active':showcatgories}">
        <div [innerHtml]="setActiveFilter" class="heading4 top-bar-dropdown-active"></div>
        <div class="dropdown-cross-wrapper">
            <span class="cross"></span>
            <span class="cross cross-rotate" [ngClass]="{'active': toggleDropdown}"></span>
        </div>
    </div>
    <div *ngIf="screenWidth <= 1024" class="dropdown-list" [ngClass]="{'active': toggleDropdown}"
        [@fadeAnimationResponsive]="categoriesmobile?.length">
        <ul>
            <li *ngFor="let category of categoriesmobile; let i = index"
                [ngClass]="{'d-none': setActiveFilter == category.name.toLowerCase() || activeAll == category.slug}"><a
                class="heading4" (click)="filterCase(category.id, category.slug, $event)">{{category.name}}</a></li>
        </ul>
    </div>
    <ul *ngIf="screenWidth > 1024 && !showSearch" [ngClass]="{'fade-categories':showcatgories}"
        [@fadeHeaderAnimation]="categories?.length">
        <li *ngFor="let category of categories; let i = index"
            [ngClass]="{'active': setActiveFilter == category.slug || activeAll == category.slug || setActiveFilter == category.name.toLowerCase() }">
            <a class="heading5" [routerLink]="['/works']" [queryParams]="{category: category.slug}" (click)="filterCase(category.id, category.slug, $event)">{{category.name}}</a></li>
    </ul>
    <!----------------------- REELS -------------------------->
    <div *ngIf="screenWidth <= 1024 && showReels" class="dropdown-list" [ngClass]="{'active': toggleDropdown}"
        [@fadeAnimationResponsive]="reels?.length">
        <ul>
            <li *ngFor="let reel of reels; let j = index" [ngClass]="{'d-none': activeReelNumber}"><a class="heading4"
                    (click)="activeReel(j)" [innerHtml]="reel.title.rendered"></a></li>
        </ul>
    </div>
    <ul *ngIf="screenWidth > 1024 && showReels" [ngClass]="{'fade-categories':showReels}"
        [@fadeHeaderAnimation]="reels?.length">
        <li *ngFor="let reel of reels; let j = index;" [ngClass]="{'active': j == activeReelNumber }"><a
                class="heading5" (click)="activeReel(j)" [innerHtml]="reel.title.rendered"></a></li>
    </ul>

    <!----------------------- SEARCH -------------------------->
    <div *ngIf="screenWidth > 1024 || showSearch" class="header-search heading5 f-silver"
        [ngClass]="{'fade-search':fadeSearch}">
        <p>Search</p>
        <p class="result-text" [ngClass]="{'result-hidden': searchingOnFocus}">Result</p>
        <p>for</p>
        <div class="search-input-wrapper">
            <input [(ngModel)]="searchModel" (focus)="searchInputOnFocus()" (blur)="searchInputOnBlur()"
                (keydown.enter)="search($event);$event.target.blur();" placeholder="{{searchText}}" class="search-input"
                type="text">
        </div>
    </div>

    <div class="fade-overlay-menu fade-overlay-menu-desktop" [ngClass]="{'active': activateMenuOverlay}"></div>
</div>